import apiUrl from "../../../constants";
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {Validator} from 'vee-validate'
import VueAlertify from 'vue-alertify';
import {BasicSelect} from 'vue-search-select'
import VueElementLoading from 'vue-element-loading';
import PageTracker from '../../../common/PageTrackerHelper'
import Paginate from 'vuejs-paginate'
import { getCountfun } from '../../../common/validations.js'
import pendingForReturn from '../common/pendingForReturn.vue'
import svcInScanPending from '../common/svcInScanPending.vue'
import shortageShipments from '../common/shortageShipments.vue'
import HanoverShipmentList from '../common/HanoverShipmentList'

export default {
  name: 'agentreturntosvc',
  components: {
  Paginate,BasicSelect,VueElementLoading,
  'pending-ForReturn' : pendingForReturn,
  'svcInScan-Pending':svcInScanPending,
  'shortage-Shipments': shortageShipments,
  'handover-shipment':HanoverShipmentList
  },
  props: [],
  mixins:[PageTracker],
  data () {
    return {
      agentname:'',
      agentitem:{id:'',text:''},
      Agent:'',
      AgentId:'',
      handovermode:'',
      vehicleno:'',
      handoverpersonname:'',
      ShippingId:'',
      awbArray1:[],
      obj:{},
      superagentsarray:[],
      showTable: false,
      returnArray:[],
      input:{
          "EntityType": "Agent"
      },
      shipmentDetails:[],
      isInScanReturntosvcLoader: false,
      change : '0',
      buttonLabel : 'InScan',
      awb:'',
      awbArray2:[],
      process:'',
      isInScanLoader: false,
      JobType: '',
      ActiveTabIndex:0,
      takeOverBTabIndex:0,
      shippingIdPendingForReturn:'',
      shippingIdSvcInScanPending:'',
      shippingIdShortageShipments:'',
      shippingIdPendingForInScan:'',
      pendingForReturnBTabs:0,
      svcInScanPendingBTabs:0,
      pendingForInScanBTabs:0,
      isLoadingList:false,
      shipmentTypePFR:'Delivery',
      shipmentTypeSVC:'Forward',
      shipmentTypePFRMdl:'Delivery',
      shipmentTypeSVCMdl:'Forward',
      shipmentTypePFI:'Delivery',
      shipmentTypePFIModal:'Delivery',
      pageNo:1,
      pageno:1,
      pageNumTakeover:1,
      pageNumTakeoverModal:1,
      pagecount:0,
      pageCount:0,
      pageCountTakeover:0,
      pageCountTakeoverModal:0,
      showPaginate:false,
      showPaginateMdl:false,
      mdlPedingForReturnBTabs:0,
      mdlSVCInScanPendingBTabs:0,
      mdlPendingForInScanBTabs:0,
      shippingIdPendingForReturnMdl:'',
      shippingIdSvcInScanPendingMdl:'',
      shippingIdShortageShipmentsMdl:'',
      shippingIdPendingForInScanMdl:'',
      mdlPendingForReturn:false,
      mdlSVCInScanPending:false,
      mdlShortageShipments:false,
      mdlPendingForInScan:false,
      isLoadingModal:false,
      modalType:'PFR',
      shippingIdPFR:true,
      shippingIdSVC:false,
      shippingIdSS:false,
      shippingIdPFI:true,
      primaryTabType:'PendingForReturn',
      shipIdPFR:false,
      shipIdSVC:false,
      shipIdSS:false,
      totalCount:'',
      totalCountTakeover:null,
      totalCountTakeoverModal:null,
      totalCountMdl:'',
      shipmentList:[],
      shipmentListTakeover:[],
      shipmentListTakeoverModal:[],
      shipmentListMdl:[],
      customAPIURL:'',
      customAPIURLModal:'',
      tempPageNo:1,
      tempPageNoMdl:1,
      returnToSvc:'',
      primaryBtabsCurrentState:'',
      change:'0',
      isRVPFeataureEnableForTesting: true,
      hubSpecificRVPAllowed: [1695,3085,614,277,93,1442,405,191,195,190,91,228,1785,2744,516,615,2046]
    }
  },
  computed: {

  },
  async mounted () {
    //this.getSuperAgents();
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.hubdetails = userdetail.hubdetails[0];
    this.mobilenumber = userdetail.mobilenumber;
    this.outsourcingid = userdetail.outsourcingid;
    this.userfullname = userdetail.username;

    let checkhub = this.hubSpecificRVPAllowed.find( value => value == this.hubdetails );
    if(process.env.NODE_ENV == 'production' && checkhub != undefined){
      this.isRVPFeataureEnableForTesting = true;
    } else if(process.env.NODE_ENV == 'development'){
      this.isRVPFeataureEnableForTesting = true;
    }

    const vm = this;
    if(this.change == '1'){
      $("#ShippingId").keydown(function (event) {
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if (keycode == 13) {
          vm.validateForm1('form-1');
          return false;
          event.stopPropagation();
        }
      });
    }
    else if(this.change == '0'){
      $("#awb").keydown(function (event) {
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if (keycode == 13) {
          vm.validateForm2('form-2');
          return false;
          event.stopPropagation();
        }
      });
    }
    this.getTakeoverPendingShipmentList();
    // this.callCommonApiFunction('PendingForReturn');
  },
  methods: {

    getPendingShipmentList(primaryType,type){

      this.$refs.paginateRefs1.selected = 0;
      this.$refs.paginateRefs2.selected = 0;
      this.$refs.paginateRefs3.selected = 0;
      this.pageNo = 1;
      this.$validator.reset()
      if (this.shippingIdPendingForReturn) {
        this.shippingIdPendingForReturn = ''
        document.getElementById('ShippingIdPendingForReturn').value = ''
      }
      if (this.shippingIdSvcInScanPending) {
        this.shippingIdSvcInScanPending = ''
        document.getElementById('ShippingIdSvcInScanPending').value = ''
      }
      if (this.shippingIdShortageShipments) {
        this.shippingIdShortageShipments = ''
        document.getElementById('ShippingIdShortageShipments').value = ''
      }

      if (primaryType === 'PendingForReturn') {

        if (type == undefined || typeof type == 'undefined') {
            this.JobType = this.shipmentTypePFR
        }
        this.primaryTabType = primaryType;
        this.modalType = 'PFR'
        this.shippingIdPFR = true;
        this.shippingIdSVC = false;
        this.shippingIdSS = false;

        if (type === 'Forward') {
          this.shipmentTypePFR = 'Delivery'
          if (this.JobType !== '') {
            this.JobType = 'Delivery';
          }
        }else if(type === 'RVP'){
          this.shipmentTypePFR = 'RVP';
          this.JobType = type;
        }else if(type === 'DTO'){
          this.shipmentTypePFR = 'DTO';
          this.JobType = type;
        }else if(type === 'RTO'){
          this.shipmentTypePFR = 'RTO';
          this.JobType = type;
        }

      }else if (primaryType === 'SVCInScanPending') {
        if (type == undefined) {
          if (this.shipmentTypeSVC === 'Forward') {
            this.JobType = 'Delivery'
          }else if(this.shipmentTypeSVC === 'Reverse'){
            this.JobType = 'RVP'
          }else {
            this.JobType = this.shipmentTypeSVC
          }
        }
        this.primaryTabType = primaryType;
        this.modalType = 'SVC'
        this.shippingIdPFR = false;
        this.shippingIdSVC = true;
        this.shippingIdSS = false;
        if (type === 'Forward') {
          this.shipmentTypeSVC = 'Forward'
          if (this.JobType !== '') {
            this.JobType = 'Delivery';
          }
        }else if(type === 'RVP'){
          this.shipmentTypeSVC = 'Reverse'
          this.JobType = type;
        }else if(type === 'DTO'){
          this.shipmentTypeSVC = 'DTO'
          this.JobType = type;
        }else if(type === 'RTO'){
          this.shipmentTypeSVC = 'RTO'
          this.JobType = type;
        }

      }else {
        this.JobType = "RVP";
        this.primaryTabType = primaryType;
        this.modalType = 'SS'
        this.shippingIdPFR = false;
        this.shippingIdSVC = false;
        this.shippingIdSS = true;

      }
      this.callCommonApiFunction(primaryType)
    },

    callCommonApiFunction(primaryType){
      this.isLoadingList = true
      if (this.shipmentList.length > 0) {
        this.shipmentList = [];
      }
      if (this.pagecount > 0) {
        this.pagecount = 0;
      }
      if (this.totalCount !== '' || this.totalCount) {
        this.totalCount = '';
      }
      if (this.showPaginate === true) {
        this.showPaginate = false;
      }
      if (primaryType === 'PendingForReturn') {
        this.input = {
          "HubId" : this.hubdetails,
          "OutSourcingMasterId" : this.outsourcingid,
          "pageNo": this.pageNo,
          "pageSize":20,
          "ShippingId":this.shippingIdPendingForReturn,
          "ShipmentType" : this.shipmentTypePFR
        }
        this.customAPIURL = apiUrl.api_url + 'expose/get/pending/for/return/shipments';
      }else if (primaryType === 'SVCInScanPending') {
        this.input = {
          "HubID":this.hubdetails,
          "OutSourcingMasterId":this.outsourcingid,
          "ShipmentStatus":"SVCInscanPending",
          "PageNo":this.pageNo,
          "PageSize":20,
          "ShippingID":this.shippingIdSvcInScanPending,
          "ShipmentType":this.shipmentTypeSVC
        }
        this.customAPIURL = apiUrl.api_url + 'rvpinscanshipment/getsareturnpendingagainsthub';
      }else {
          this.input = {
          "HubID": this.hubdetails,
          "OutSourcingMasterId":this.outsourcingid,
          "ShipmentStatus":"SAReturnPending",
          "PageNo":this.pageNo,
          "PageSize":20,
          "ShippingID":this.shippingIdShortageShipments,
          "ShipmentType":'Reverse'
          }
          this.customAPIURL = apiUrl.api_url + 'rvpinscanshipment/getsareturnpendingagainsthub';
      }
      axios({
        method:'POST',
        url: this.customAPIURL,
        data:this.input
      }).then(result =>{
        this.isLoadingList = false

        if (result.data.code === 200) {
        this.showPaginate = true
        if (primaryType === 'PendingForReturn') {
          this.shipmentList = result.data.data
          this.totalCount = result.data.TotalCount
        }else {
          this.shipmentList = result.data.result.Shipments
          this.totalCount = result.data.result.TotalShipments;
        }

        if (this.totalCount < 20) {
          this.pagecount = 1
        }else {
          this.pagecount = Math.ceil(this.totalCount / 20)
        }
        }
      }).catch(err =>{
        this.isLoadingList = false
        console.log("Error Details", err);
        return false
      })

    },
    switchTakeOverTabs(type){
      if (this.shippingIdPendingForInScan) {
        this.shippingIdPendingForInScan = '';
        document.getElementById('ShippingIdPendingForInScan').value = '';
      }
      if (this.$refs.handoverShipments.$refs.paginate.selected > 0) {
        this.$refs.handoverShipments.$refs.paginate.selected = 0
       }
       if (type) {
         this.shipmentTypePFI = type;
       }
      this.pageNumTakeover = 1;
      this.getTakeoverPendingShipmentList()
    },
    getTakeoverPendingShipmentList(){
      let takeoverPayload = {};

      if (this.mdlPendingForInScan) {
        this.isLoadingModal = true;
        takeoverPayload = {
        "ShipmentType": this.shipmentTypePFIModal,
        "HubId" : this.hubdetails,
        "OutSourcingMasterId" : this.outsourcingid,
        "pageNo": this.pageNumTakeoverModal,
        "pageSize":20,
        }
      }else{
        this.isLoadingList = true;
        takeoverPayload = {
        "ShipmentType": this.shipmentTypePFI,
        "HubId" : this.hubdetails,
        "OutSourcingMasterId" : this.outsourcingid,
        "pageNo": this.pageNumTakeover,
        "pageSize":20,
        }
      }
      if (this.shippingIdPendingForInScan) {
        takeoverPayload.ShippingId = this.shippingIdPendingForInScan;
        takeoverPayload.pageNo = 0;
      }
      if (this.shippingIdPendingForInScanMdl) {
        takeoverPayload.ShippingId = this.shippingIdPendingForInScanMdl;
        takeoverPayload.pageNo = 0;
      }

      axios({
        method:'POST',
        url:apiUrl.api_url + 'pending/shipments/byHubID',
        data:takeoverPayload
      }).then(result =>{
        if (this.mdlPendingForInScan) {
          this.isLoadingModal = false;
          if (result.data.code === 200) {
            this.shipmentListTakeoverModal = result.data.data
            this.totalCountTakeoverModal = result.data.totalcount;

            if (this.totalCountTakeoverModal < 20) {
              this.pageCountTakeoverModal = 1
            }else {
              this.pageCountTakeoverModal = Math.ceil(this.totalCountTakeoverModal / 20)
            }
          }else {
            this.pageCountTakeoverModal = 1;
            this.totalCountTakeoverModal = 0;
            this.shipmentListTakeoverModal = [];
          }
        }else {
          this.isLoadingList = false;
          if (result.data.code === 200) {
            this.shipmentListTakeover = result.data.data
            this.totalCountTakeover = result.data.totalcount;

            if (this.totalCountTakeover < 20) {
              this.pageCountTakeover = 1
            }else {
              this.pageCountTakeover = Math.ceil(this.totalCountTakeover / 20)
            }
          }else {
            this.pageCountTakeover = 1;
            this.totalCountTakeover = 0;
            this.shipmentListTakeover = [];
          }
        }
      }).catch(err =>{
        console.log("Error Details", err);
        return false;
      })
    },
    switchTakoverModalTabs(type){
      if (this.$refs.handoverShipmentsMdl.$refs.paginate.selected > 0) {
        this.$refs.handoverShipmentsMdl.$refs.paginate.selected = 0
       }
       if (this.shippingIdPendingForInScanMdl) {
         this.shippingIdPendingForInScanMdl = '';
         document.getElementById('ShippingIdPendingForInScanMdl').value = '';
       }
      this.pageNumTakeoverModal = 1;
      this.shipmentTypePFIModal = type;
      this.getTakeoverPendingShipmentList();
    },
    getHandoverPaginationData(pageNum){
      this.pageNumTakeover = pageNum;
      this.getTakeoverPendingShipmentList();
    },
    getHandoverPaginationDataModal(pageNum){
      this.pageNumTakeoverModal = pageNum;
      this.getTakeoverPendingShipmentList();
    },
    getModalPrimaryTabList(primaryType, type){
      // Clear Fields {
      if (this.shipmentListMdl.length > 0) {
        this.shipmentListMdl = [];
      }
      if (this.pageCount > 0) {
        this.pageCount = 0;
      }
      if (this.totalCountMdl !== '' || this.totalCountMdl) {
        this.totalCountMdl = '';
      }
      if (this.showPaginateMdl === true) {
        this.showPaginateMdl = false;
      }
      //  }  Clear Fields


      this.isLoadingModal = true;
      var primaryTabTypeMdl = '';
      primaryTabTypeMdl = primaryType == ('' || undefined || null) ? 'PFR' : primaryType;

      if (primaryTabTypeMdl === 'PFR') {
        this.input = {
          "HubId" : this.hubdetails,
          "OutSourcingMasterId" : this.outsourcingid,
          "pageNo": this.pageno,
          "pageSize":20,
          "ShippingId":this.shippingIdPendingForReturnMdl,
          "ShipmentType" : this.shipmentTypePFRMdl
        }
        this.customAPIURLModal = apiUrl.api_url + 'expose/get/pending/for/return/shipments'

      }else if (primaryTabTypeMdl === 'SVC') {
        this.input = {
          "HubID":this.hubdetails,
          "OutSourcingMasterId":this.outsourcingid,
          "ShipmentStatus":"SVCInscanPending",
          "PageNo":this.pageno,
          "PageSize":10,
          "ShippingID":this.shippingIdSvcInScanPendingMdl,
          "ShipmentType":this.shipmentTypeSVCMdl
        }
        this.customAPIURLModal = apiUrl.api_url + 'rvpinscanshipment/getsareturnpendingagainsthub'

      }else {
        this.input = {
        "HubID": this.hubdetails,
        "OutSourcingMasterId":this.outsourcingid,
        "ShipmentStatus":"SAReturnPending",
        "PageNo":this.pageno,
        "PageSize":20,
        "ShippingID":this.shippingIdShortageShipmentsMdl,
        "ShipmentType":'Reverse'
        }
        this.customAPIURLModal = apiUrl.api_url + 'rvpinscanshipment/getsareturnpendingagainsthub'

      }
        axios({
          method:'POST',
          url: this.customAPIURLModal,
          data:this.input
        }).then(result =>{
          this.isLoadingModal = false
          if (result.data.code === 200) {
            this.showPaginateMdl = true;
            if (primaryTabTypeMdl === 'PFR') {
                this.shipmentListMdl = result.data.data;
                this.totalCountMdl = result.data.TotalCount;
            }else {
              this.shipmentListMdl = result.data.result.Shipments;
              this.totalCountMdl = result.data.result.TotalShipments;
            }

            if (this.totalCountMdl < 20) {
              this.pageCount = 1;
            }else {
              this.pageCount = Math.ceil(this.totalCount / 20)
            }
          }
        }).catch(err =>{
          this.isLoadingModal = false
          console.log("Error Details", err);
          return false
        })
    },
    switchTabsModal(primaryType,type){
      this.$validator.reset()
      if (this.shippingIdPendingForReturnMdl) {
        this.shippingIdPendingForReturnMdl = ''
        document.getElementById('ShippingIdPendingForReturnMdl').value = ''
      }
      if (this.shippingIdSvcInScanPendingMdl) {
        this.shippingIdSvcInScanPendingMdl = ''
        document.getElementById('ShippingIdSvcInScanPendingMdl').value = ''
      }
      if (this.shippingIdShortageShipmentsMdl) {
        this.shippingIdShortageShipmentsMdl = ''
        document.getElementById('ShippingIdShortageShipmentsMdl').value = ''
      }
      this.$refs.paginateRefsMdl1.selected = 0;
      this.$refs.paginateRefsMdl2.selected = 0;
      this.pageno = 1;
      if (primaryType === 'PFR') {
        if (type === 'Forward') {
          this.shipmentTypePFRMdl = 'Delivery'
        }else if(type === 'RVP'){
          this.shipmentTypePFRMdl = 'RVP'
        }else if(type === 'DTO'){
          this.shipmentTypePFRMdl = 'DTO'
        }else if(type === 'RTO'){
          this.shipmentTypePFRMdl = 'RTO'
        }

      }else if (primaryType === 'SVC') {
        if (type === 'Forward') {
          this.shipmentTypeSVCMdl = 'Forward'
        }else if(type === 'RVP'){
          this.shipmentTypeSVCMdl = 'Reverse'
        }else if(type === 'DTO'){
          this.shipmentTypeSVCMdl = 'DTO'
        }else if(type === 'RTO'){
          this.shipmentTypeSVCMdl = 'RTO'
        }
      }
      this.getModalPrimaryTabList(primaryType)
    },
    checkShippingId(scope){
      this.$validator.validateAll(scope).then(res => {
          if (res === false) {
            this.$alertify.error("Please Enter Only AlphaNumeric Shipping Id!")
            return false
          }else {
            if (this.pageNo > 1) {
              this.tempPageNo = this.pageNo;
              this.pageNo = 0;
            }
            this.callCommonApiFunction(this.primaryTabType);
            return false
          }
      }).catch(err =>{
        console.log("Error Detils", err);
        return false
      })
    },
    checkShippingIdMdl(scope){
      this.$validator.validateAll(scope).then(res =>{
          if (res === false) {
            this.$alertify.error("Please Enter Shipping Id!")
            return false
          }else {
            if (this.pageno > 1) {
              this.tempPageNoMdl = this.pageno;
              this.pageno = 0;
            }
            this.getModalPrimaryTabList(this.modalType);
            return false;
          }
      }).catch(err =>{
        console.log("Error Detils", err);
        return false
      })
    },
    refresh(primaryType){
      this.$validator.reset()
      if (this.shippingIdPendingForReturn) {
        this.shippingIdPendingForReturn = ''
        document.getElementById('ShippingIdPendingForReturn').value = ''
      }
      if (this.shippingIdSvcInScanPending) {
        this.shippingIdSvcInScanPending = ''
        document.getElementById('ShippingIdSvcInScanPending').value = ''
      }
      if (this.shippingIdShortageShipments) {
        this.shippingIdShortageShipments = ''
        document.getElementById('ShippingIdShortageShipments').value = ''
      }
      if (this.shippingIdPendingForInScan) {
        this.shippingIdPendingForInScan = ''
        document.getElementById('ShippingIdPendingForInScan').value = ''
      }

      if (this.pageNo === 0) {
        this.pageNo = this.tempPageNo;
      }
      if (this.pageno === 0) {
        this.pageno = this.tempPageNoMdl;
      }
      if (primaryType === 'PendingForReturn') {
        this.callCommonApiFunction(primaryType)
      }
      if (primaryType === 'SVCInScanPending') {
        this.callCommonApiFunction(primaryType)
      }
      if(primaryType === 'ShortageShipments'){
        this.callCommonApiFunction(primaryType)
      }
      if (primaryType === 'PendingForInScan') {
        this.getTakeoverPendingShipmentList();
      }

      if (this.shippingIdPendingForReturnMdl) {
        this.shippingIdPendingForReturnMdl = ''
        document.getElementById('ShippingIdPendingForReturnMdl').value = '';
      }
      if (this.shippingIdSvcInScanPendingMdl) {
        this.shippingIdSvcInScanPendingMdl = '';
        document.getElementById('ShippingIdSvcInScanPendingMdl').value = '';
      }
      if (this.shippingIdShortageShipmentsMdl) {
        this.shippingIdShortageShipmentsMdl = '';
        document.getElementById('ShippingIdShortageShipmentsMdl').value = '';
      }
      if (this.shippingIdPendingForInScanMdl) {
        this.shippingIdPendingForInScanMdl = '';
        document.getElementById('ShippingIdPendingForInScanMdl').value = '';
      }

      if (primaryType === 'PFR') {
        this.getModalPrimaryTabList(primaryType)
      }
      if(primaryType === 'SVC'){
        this.getModalPrimaryTabList(primaryType)
      }
      if(primaryType === 'SS'){
        this.getModalPrimaryTabList(primaryType)
      }
      if(primaryType === 'PFI'){
        this.getTakeoverPendingShipmentList()
      }
    },
    openModal(primaryType){
      if (primaryType === 'PFR') {
        // this.$validator.reset()
        if (this.shippingIdPendingForReturnMdl) {
          this.shippingIdPendingForReturnMdl = '';
          document.getElementById('ShippingIdPendingForReturnMdl').value = '';
        }
        this.shipIdPFR = true;
        this.shipIdSVC = false;
        this.shipIdSS = false;
        this.mdlPendingForReturn = true;
        this.getModalPrimaryTabList(primaryType)
      }else if(primaryType === 'SVC'){
        if (this.shippingIdSvcInScanPendingMdl) {
          this.shippingIdSvcInScanPendingMdl = '';
          document.getElementById('ShippingIdSvcInScanPendingMdl').value = '';
        }
        this.shipIdPFR = false;
        this.shipIdSVC = true;
        this.shipIdSS = false;
        this.mdlSVCInScanPending = true
        this.getModalPrimaryTabList(primaryType)
      }else if(primaryType === 'PFI') {
          if (this.shippingIdPendingForInScanMdl) {
            this.shippingIdPendingForInScanMdl = '';
            document.getElementById('ShippingIdPendingForInScanMdl').value = '';
          }
          this.mdlPendingForInScan = true;
          this.getTakeoverPendingShipmentList();
      }else {
        if (this.shippingIdShortageShipmentsMdl) {
          this.shippingIdShortageShipmentsMdl = '';
          document.getElementById('ShippingIdShortageShipmentsMdl').value = '';
        }
        this.shipIdPFR = false;
        this.shipIdSVC = false;
        this.shipIdSS = true;
        this.mdlShortageShipments = true;
        this.getModalPrimaryTabList(primaryType);
      }
    },
    closeModal(primaryType){
      this.pageno = 1;
      this.$refs.paginateRefsMdl1.selected = 0;
      this.$refs.paginateRefsMdl2.selected = 0;
      this.$refs.paginateRefsMdl3.selected = 0;
      if (primaryType === 'PFR') {
        this.mdlPendingForReturn = false;
      }else if(primaryType === 'SVC'){
        this.mdlSVCInScanPending = false;
      }if (primaryType === 'PFI') {
        this.mdlPendingForInScan = false;
      }else {
        this.mdlShortageShipments = false;
      }

    },
    getPaginationShipmentListData(pageNum){
      this.pageNo = pageNum;
      this.callCommonApiFunction(this.primaryTabType)
    },
    getPaginationShipmentListDataMdl(pageNum){
      this.pageno = pageNum
      this.getModalPrimaryTabList(this.modalType)
    },
    jobTypeSelected(primaryType){
      if (this.ShippingId) {
        this.ShippingId = '';
      }
      if (primaryType === 'PendingForReturn') {
        if (this.JobType === 'Delivery') {
          this.pendingForReturnBTabs = 0;
          this.shipmentTypePFR = 'Delivery';
        }else if(this.JobType === 'RVP'){
          this.pendingForReturnBTabs = 1;
          this.shipmentTypePFR = 'RVP';
        }else if(this.JobType === 'DTO'){
          this.pendingForReturnBTabs = 2;
          this.shipmentTypePFR = 'DTO';
        }else if(this.JobType === 'RTO'){
          this.pendingForReturnBTabs = 3;
          this.shipmentTypePFR = 'RTO';
        }else {
          this.JobType = '';
          this.pendingForReturnBTabs = 0;
        }
      }
      if (primaryType === 'SVCInScanPending') {
        if (this.JobType === 'Delivery') {
          this.svcInScanPendingBTabs = 0;
          this.shipmentTypeSVC = 'Forward';
        }else if(this.JobType === 'RVP'){
          this.svcInScanPendingBTabs = 1;
          this.shipmentTypeSVC = 'Reverse';
        }else if(this.JobType === 'DTO'){
          this.svcInScanPendingBTabs = 2;
          this.shipmentTypeSVC = 'DTO';
        }else if(this.JobType === 'RTO'){
          this.svcInScanPendingBTabs = 3;
          this.shipmentTypeSVC = 'RTO';
        }else {
          this.JobType = '';
          this.svcInScanPendingBTabs = 0;
        }
      }

    },
    getPaginationShipmentListData(pageNum){
      this.pageNo = pageNum;
      this.callCommonApiFunction(this.primaryTabType)
    },
    getPaginationShipmentListDataMdl(pageNum){
      this.pageno = pageNum
      this.getModalPrimaryTabList(this.modalType)
    },
    KeycheckFunction(event){
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if (keycode == 13) {
        this.validateForm1('form-1');
        return false;
        event.stopPropagation();
      }
    },
    validateForm1(scope) {
      this.$validator.validateAll(scope).then(result => {
        // let validateStatus = true;
        // console.log('this.$refs.PendingShipments.selectedReverseShipmentData.',this.$refs.PendingShipments.selectedReverseShipmentData);
        // if(this.JobType == 'RVP') {
        //   if(this.$refs.PendingShipments.selectedReverseShipmentData.length == 0 ){
        //     this.$alertify.error('Please select atleast one shipment from Available for transfer list.!');
        //     validateStatus = false;
        //   }else if(this.$refs.PendingShipments.selectedReverseShipmentData.length > 100) {
        //     this.$alertify.error('Please select only maximum 100 Shipping ids.!');
        //     validateStatus = false;
        //   }
        // }

        // if (result && validateStatus) {
        if (result){
          this.isInScanReturntosvcLoader = true;
          this.awbArray1 = [];
          // if (this.JobType === 'RVP') {
          //   this.awbArray1 = this.$refs.PendingShipments.selectedReverseShipmentData;
          // }else {
            let shippingidsWithNextLine = this.ShippingId.split("\n").map(String);
            let shippingidsWithComma = this.ShippingId.split(",").map(String);
            if(shippingidsWithNextLine.length > 1) {

              $.each(shippingidsWithNextLine, (key,sid)=>{
                if(sid != null && sid !=''){
                  this.awbArray1.push(sid.trim());
                }
              })
            } else if(shippingidsWithComma.length >= 1){
              $.each(shippingidsWithComma, (key,sid)=>{
                if(sid != null && sid !=''){
                  this.awbArray1.push(sid.trim());
                }
              })
            }
          // }
          let userProcessCode = 'XBU00278';
          if(this.JobType == 'RTO'){
            userProcessCode = 'XBU00559';
          } else if(this.JobType == 'Delivery' || this.JobType == 'DTO'){
            userProcessCode = 'XBU00278';
          } else if(this.JobType == 'RVP') {
            userProcessCode = 'XBU00581';
          }

          let obj = {
            couriercompanyid:this.outsourcingid,
            couriercompanyname:this.userfullname,
            couriercompanyphone:this.mobilenumber,
            handovermode:this.handovermode,
            vehicleno:this.vehicleno,
            handoverpersonname:this.handoverpersonname,
            awb:this.awbArray1,
            hubid:this.hubdetails.toString(),
            userProcessCode: userProcessCode,
          }
          if (this.JobType !== '' && this.JobType !== null) {
            obj.jobType = this.JobType;
          }

          axios({
              method: 'POST',
              'url':  apiUrl.api_url + 'AgentHandoverReturn/HandoverReturn',
              'data': obj,
              header:{
                'content-type': 'application/json'
              }
          }).then(result => {
              let TrackerInfo = {
                  projectname:"Last Mile",
                  type:"Web",
                  userid:this.localuserid,
                  username:this.userfullname,
                  meta: {
                      "event":"agentReturnShipments",
                      "couriercompanyname":this.userfullname,
                      "vehicleno":this.vehicleno,
                      "handoverpersonname":this.handoverpersonname,
                      "shippingId":this.awbArray1.toString()
                  }
              }
              this.PageTracker(TrackerInfo);
              this.isInScanReturntosvcLoader = false;
              this.showTable = true;
              this.awbArray1 = [];
              let arrayui=[];
              this.returnArray = result.data.data;
              if(result.data.code != 200){
                this.$alertify.error(result.data.message);
              }
              this.ShippingId='';
              this.refresh(this.primaryTabType);
              this.$validator.reset();
              this.errors.clear();
          })
          .catch((httpException) => {
            this.$alertify.error("Something went wrong!!");
            console.log('exception is:::::::::', httpException)
            this.isInScanReturntosvcLoader = false;
          });
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
        this.isInScanReturntosvcLoader = false;
      });
    },
    SelectAgent(agentitem){
      this.agentitem=agentitem
      this.Agent=this.agentitem.text
      this.AgentId=this.agentitem.id
    },
    resetForm1(){
      this.agent=''
      this.agentname=''
      this.handovermode=''
      this.vehicleno=''
      this.handoverpersonname=''
      this.ShippingId=''
      this.awbArray1=[]
      this.obj={}
      this.showTable= false
      this.returnArray=[]
      this.isInScanReturntosvcLoader = false;
      this.JobType = ''
      this.$validator.reset();
      this.errors.clear();
    },
    resetForm2(){
      this.agent=''
      this.agentname=''
      this.handovermode=''
      this.vehicleno=''
      this.process = ''
      this.handoverpersonname=''
      this.awb=''
      this.awbArray2=[]
      this.obj={}
      this.showTable= false
      this.returnArray=[]
      this.isInScanLoader = false;
      this.$validator.reset();
      this.errors.clear();
    },
    clearAll(value){
      this.resetForm1()
      this.resetForm2()
      if(this.change == 0){
        this.pendingForInScanBTabs = 0;
        this.pageNumTakeover = 1;
        this.shipmentTypePFI = 'Delivery'
        this.getTakeoverPendingShipmentList();
      } else {
        if (this.$refs.paginateRefs1 !== undefined) {
          if (this.$refs.paginateRefs1.selected !== 0) {
            this.$refs.paginateRefs1.selected = 0;
           }
        }
        this.ActiveTabIndex = 0;
        this.pendingForReturnBTabs = 0;
        this.modalType = 'PFR'
        this.shipmentTypePFR = 'Delivery';
        this.shipmentTypePFRMdl = 'Delivery';
        if (this.shippingIdPendingForReturn) {
          this.shippingIdPendingForReturn = '';
          document.getElementById('ShippingIdPendingForReturn').value = '';
        }
        this.callCommonApiFunction('PendingForReturn');
      }
    },
    ChangeLabelName(){
      this.buttonLabel = this.process == 'Shortage' ? 'Mark Shortage' : 'InScan';
    },
    validateForm2(scope) {
      this.$validator.validateAll(scope).then(async result => {
        if (result) {
          this.isInScanLoader = true;
          let shippingidsWithNextLine = this.awb.split("\n").map(String);
          let shippingidsWithComma = this.awb.split(",").map(String);

          if(shippingidsWithNextLine.length > 1) {

            $.each(shippingidsWithNextLine, (key,sid)=>{
              if(sid != null && sid !=''){
                this.awbArray2.push(sid.trim());
              }
            })
          } else if(shippingidsWithComma.length >= 1){

            $.each(shippingidsWithComma, (key,sid)=>{
              if(sid != null && sid !=''){
                this.awbArray2.push(sid.trim());
              }
            })
          }

          this.obj.couriercompanyid = this.outsourcingid;
          this.obj.couriercompanyname = this.userfullname;
          this.obj.couriercompanyphone = this.mobilenumber;
          this.obj.process = this.process;
          this.obj.awb = this.awbArray2;
          this.obj.createdby = "Agent";

          await axios.post(apiUrl.api_url +`AgentInscan/Inscan`,this.obj
           ).then(result => {
              let TrackerInfo = {
                projectname:"Last Mile",
                type:"Web",
                userid:this.localuserid,
                username:this.userfullname,
                meta: {
                    "event":"agentInscan",
                    "couriercompanyname":this.userfullname,
                    "shippingId":this.awbArray2.toString()
                }
              }
              this.PageTracker(TrackerInfo);
              this.awb='';
              this.showTable = true;
              this.returnArray = result.data.data;
              if(result.data.code == 200 ) {
                this.returnArray = result.data.data;
                this.$validator.reset();
                this.errors.clear();
                this.getTakeoverPendingShipmentList()
              } else {
                this.$validator.reset();
                this.errors.clear();
                this.$alertify.error(result.data.message);
              }
              this.isInScanLoader = false;
              this.awbArray2 = [];
        })
        .catch((httpException) => {
            this.$alertify.error("Something went wrong!!");
            console.error('exception is:::::::::', httpException)
            this.isInScanLoader = false;
        });

        }
      }).catch(() => {
        console.log('errors exist', this.errors)
        this.isInScanLoader = false;
      });
    },
  }
}

Validator.extend('VerifyShippingidFormatForSVC1', {
  getMessage: field => "maximum 100 Shipping ids you can enter",
  validate: async value => {
      var shippingids = $("#ShippingId").val();
      let cnt = await getCountfun(shippingids);
      return cnt;
  }
});
Validator.extend('VerifyShippingidFormatForSVC2', {
  getMessage: field => "maximum 100 Shipping ids you can enter",
  validate: async value => {
      var shippingids = $("#awb").val();
      let result = await getCountfun(shippingids);
      return result;
  }
});



// WEBPACK FOOTER //
// ./src/views/components/agentreturntosvc/agentreturntosvc.component.js